import { render, staticRenderFns } from "./tierDiscount.vue?vue&type=template&id=0763cb9f&scoped=true&"
import script from "./tierDiscount.vue?vue&type=script&lang=ts&"
export * from "./tierDiscount.vue?vue&type=script&lang=ts&"
import style0 from "./tierDiscount.vue?vue&type=style&index=0&id=0763cb9f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0763cb9f",
  null
  
)

export default component.exports